<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize">{{ refs }}

                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->

                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Add New</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->


        <form @submit.prevent="addNew" enctype="multipart/form-data" class="h-100">

            <!-- Content -->
            <div class="tab-content">
                <div class="row">        
                    <div class="col-md-8 mb-5">


                    <!-- Card Meta -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabMeta" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Meta')"
                                            aria-expanded="false" 
                                            aria-controls="collapseMeta" 
                                            data-toggle="collapse"
                                            data-target="#collapseMeta">Meta
                                            <span id="iconToggleMeta" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseMeta" 
                                        class="collapse show" 
                                        aria-labelledby="TabMeta" 
                                        data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- Meta title -->
                                        <div class="form-group">
                                            <div class="pull-right f12" 
                                                v-if="row.meta_title"
                                                v-text="(row.meta_title.length)">
                                            </div>
                                            <label for="inputText4">Meta title</label>
                                            <input class="form-control"
                                                    id="inputText4"  
                                                    type="text" 
                                                    v-model="row.meta_title">
                                        </div>
                                        <!-- End Meta title -->
                                            
                                        <!-- Meta keywords -->
                                        <div class="form-group">
                                            <div class="pull-right f12"
                                                v-if="row.meta_keywords" 
                                                v-text="(row.meta_keywords.length)">
                                            </div>
                                            <label for="inputText5">Meta keywords</label>
                                            <textarea class="form-control"
                                                    id="inputText5" 
                                                    rows="5"  
                                                    v-model="row.meta_keywords">
                                            </textarea>
                                        </div>
                                        <!-- End Meta keywords -->

                                        <!-- Meta description -->
                                        <div class="form-group">
                                            <div class="pull-right f12" 
                                                v-if="row.meta_description" 
                                                v-text="(row.meta_description.length)">
                                            </div>
                                            <label for="inputText6">Meta description</label>
                                            <textarea class="form-control" 
                                                    id="inputText6" 
                                                    rows="5" 
                                                    v-model="row.meta_description">
                                            </textarea>
                                        </div>
                                        <!-- End Meta description -->

                                        </div>

                                        <div class="row">
                                            <div class="col-6 pt-3">
                                                <!-- Site Map Changefreq -->
                                                <div class="form-group">
                                                    <label for="inputText444">Site Map Changefreq</label>
                                                    <select class="form-control" 
                                                            id="inputText444" 
                                                            v-model="row.sitemap_freq">
                                                        <option value="always">always</option>
                                                        <option value="hourly">hourly</option>
                                                        <option value="daily">daily</option>
                                                        <option value="weekly">weekly</option>
                                                        <option value="monthly" selected>monthly</option>
                                                        <option value="yearly">yearly</option>
                                                        <option value="never">never</option>
                                                    </select>
                                                </div>
                                                <!-- Site Map Changefreq -->
                                            </div>

                                            <div class="col-6 pt-3">
                                                <!-- Site Map Priority -->
                                                    <div class="form-group">
                                                        <label for="inputText555">Site Map Priority</label>
                                                        <select class="form-control" 
                                                                id="inputText555" 
                                                                v-model="row.sitemap_priority">
                                                            <option value="0.0">0.0</option>
                                                            <option value="0.1">0.1</option>
                                                            <option value="0.2">0.2</option>
                                                            <option value="0.3">0.3</option>
                                                            <option value="0.4">0.4</option>
                                                            <option value="0.5" selected>0.5</option>
                                                            <option value="0.6">0.6</option>
                                                            <option value="0.7">0.7</option>
                                                            <option value="0.8">0.8</option>
                                                            <option value="0.9">0.9</option>
                                                            <option value="1.0">1.0</option>
                                                        </select>
                                                    </div>
                                                <!-- End Site Map Priority -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End CarDMeta -->


                        <!-- CardDest -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabPage" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Page')"
                                            aria-expanded="false" 
                                            aria-controls="collapsePage" 
                                            data-toggle="collapse"
                                            data-target="#collapsePage">Page
                                            <span id="iconTogglePage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapsePage" 
                                        class="collapse" 
                                        aria-labelledby="TabPage" 
                                        data-parent="#accordion">

                                <div class="col-12 pt-3">
                                    
                                    <!-- Page Title -->
                                    <div class="form-group">
                                        <label for="inputText0">Page Title</label>
                                        <input class="form-control" 
                                                id="inputText0" 
                                                type="text" 
                                                v-model="row.page_title">
                                    </div>
                                    <!-- End Page Title -->

                                    <!-- Title -->
                                    <div class="form-group">
                                        <label for="inputText1">Title</label>
                                        <input class="form-control" 
                                                id="inputText1" 
                                                type="text" 
                                                v-model="row.title">
                                    </div>
                                    <!-- End Title -->

                                    <!-- Slug -->
                                    <div class="form-group">
                                        <label for="inputText2">Slug</label>
                                        <input class="form-control"
                                                id="inputText2"  
                                                type="text" 
                                                v-model="row.slug" 
                                                @keydown.space.prevent>
                                    </div>
                                    <!-- End Slug -->

                                    <!-- Sort -->
                                    <div class="form-group">
                                        <label for="inputText3">Sort</label>
                                        <input class="form-control" 
                                                id="inputText3" 
                                                type="number" 
                                                min="0"
                                                v-model.number="row.sort">
                                    </div>
                                    <!-- End Sort -->

                                    <!-- Body -->
                                    <div class="form-group">
                                        <label for="inputEditor1">Body</label>
                                        <editor
                                            id="inputEditor1"
                                            v-model="row.body"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 900,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End CardDest -->


                </div>





                    <!-- ******* SideNavbar ******** -->
                    <div class="col-md-4 mb-5">

                        <!-- Nav Language -->
                        <div class="card">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavLanguage" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Language')" 
                                            aria-expanded="false" 
                                            aria-controls="collapseNavLanguage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavLanguage">Language
                                            <span id="iconToggleLanguage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavLanguage" 
                                        class="collapse" 
                                        aria-labelledby="NavLanguage" 
                                        data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <!-- Language -->
                                        <div class="form-group">
                                            <div v-if="languageLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                    v-if="!languageLoading" 
                                                    v-model="row.language_id">
                                                    <option value="">Select Language</option>
                                                    <option v-for="(language, index) in languages" 
                                                            :key="index"
                                                            :value="language.id">
                                                            {{ language.name }}
                                                    </option>
                                            </select>
                                        </div>
                                        <!-- End Language -->
                                    </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Nav Language -->

                        <!-- NavTwo -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavImage" class="card-header">
                                        <h2 class="h4 card-header-title"
                                            @click="collapseToggle('Image')"  
                                            aria-expanded="false" 
                                            aria-controls="collapseNavImage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavImage">Featued Image
                                            <span id="iconToggleImage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavImage" 
                                        class="collapse" 
                                        aria-labelledby="NavImage" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Image -->
                                            <div class="form-group">
                                                <label>Image</label>
                                                <img v-if="row.image_preview" 
                                                    :src="row.image_preview" 
                                                    class="mb-2 custom-image">
                                                <input type="file" 
                                                    class="form-control" 
                                                    ref="myDropify" 
                                                    v-on:change="onImageChange"
                                                    accept="image/*">
                                            </div>
                                            <div class="form-group">
                                                <label>Image alt</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_alt">
                                            </div>
                                            <div class="form-group">
                                                <label>Image title</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_title">
                                            </div>
                                            <!-- Image -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End NavTwo -->

                        <!-- Nav Mobile Image -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="MobileNavImage" class="card-header">
                                        <h2 class="h4 card-header-title"
                                            @click="collapseToggle('MobileImage')"  
                                            aria-expanded="false" 
                                            aria-controls="collapseMobileNavImage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseMobileNavImage">Mobile Featured Image
                                            <span id="iconToggleMobileImage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseMobileNavImage" 
                                        class="collapse" 
                                        aria-labelledby="MobileNavImage" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                             <!-- Image -->
                                            <div class="form-group">
                                                <label>Image</label>
                                                <img v-if="row.mobile_image_preview"
                                                    :src="row.mobile_image_preview" 
                                                    class="mb-2 custom-image">
                                                <input type="file" 
                                                    class="form-control" 
                                                    ref="myDropify" 
                                                    v-on:change="onMobileImageChange"
                                                    accept="image/*">
                                            </div>
                                            <!-- Image -->

                                            <!-- Image Alt -->
                                            <div class="form-group">
                                                <label>Image alt</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.mobile_image_alt">
                                            </div>
                                            <!-- End Image Alt -->

                                            <!-- Image Title -->
                                            <div class="form-group">
                                                <label>Image title</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.mobile_image_title">
                                            </div>
                                            <!-- End Image Title -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Mobile Image -->

                        <!-- Linked FAQs -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavFaqs" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Faqs')"
                                            aria-expanded="false" 
                                            aria-controls="collapseNavFaqs" 
                                            data-toggle="collapse"
                                            data-target="#collapseNavFaqs">Linked FAQs
                                            <span id="iconToggleFaqs" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavFaqs" 
                                        class="collapse" 
                                        aria-labelledby="NavFaqs" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <p class="text-muted small">Order follows selection order in the list.</p>
                                            <div class="form-group">
                                                <div v-if="faqsLoading" class="text-center">
                                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                                        role="status" 
                                                        aria-hidden="true">
                                                    </span>
                                                </div>
                                                <multiselect v-if="!faqsLoading"
                                                    id="multiselect-faqs-pages"
                                                    v-model="row.faqsValues" 
                                                    :options="faqsOptions" 
                                                    :multiple="true"
                                                    :close-on-select="false" 
                                                    :clear-on-select="false" 
                                                    :hide-selected="true" 
                                                    :preserve-search="true" 
                                                    :taggable="false"
                                                    label="title"
                                                    track-by="id"
                                                    placeholder="Search and select FAQs"
                                                    :preselect-first="false">
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Linked FAQs -->

                        <!-- NavThree -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavStatus" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Status')"
                                            aria-expanded="false" 
                                            aria-controls="collapseNavStatus" 
                                            data-toggle="collapse"
                                            data-target="#collapseNavStatus">Status & Visibility
                                            <span id="iconToggleStatus" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavStatus" 
                                        class="collapse" 
                                        aria-labelledby="NavStatus" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Status -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch1" 
                                                        :checked="row.status"
                                                        @click="onStatus">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch1"
                                                        v-html="(row.status) ? 'Active' : 'Inactive'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End Status -->

                                            <!-- View in home -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch2" 
                                                        :checked="row.view_in_home"
                                                        @click="onViewInHome">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch2"
                                                        v-html="(row.view_in_home) 
                                                            ? 'Show In Home' 
                                                            : 'Hide In Home'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in home -->

                                            <!-- View in sitemap -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch22" 
                                                        :checked="row.view_in_sitemap"
                                                        @click="onSitemap">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch22"
                                                        v-html="(row.view_in_sitemap) 
                                                            ? 'Show In Sitemap' 
                                                            : 'Hide In Sitemap'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in sitemap -->

                                            <!-- View in menu -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch5" 
                                                        :checked="row.view_in_menu"
                                                        @click="onViewInMenu">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch5"
                                                        v-html="(row.view_in_menu) 
                                                            ? 'Show In Menu' 
                                                            : 'Hide In Menu'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in menu -->

                                            <!-- Menu Order -->
                                            <div class="no-rpadding">
                                                <div class="form-group">
                                                    <input class="form-control"
                                                            v-bind:style="{display: orderDisplay}"
                                                            placeholder="Order In Menu" 
                                                            id="inputText8" 
                                                            type="number"
                                                            min="0" 
                                                            v-model.number="row.menu_order">
                                                </div>
                                            </div>
                                            <!-- End Menu Order -->

                                            <!-- View in sub menu -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch6" 
                                                        :checked="row.view_in_sub_menu"
                                                        @click="onViewInSubMenu">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch6"
                                                        v-html="(row.view_in_sub_menu) 
                                                            ? 'Show In Sub Menu' 
                                                            : 'Hide In Sub Menu'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in sub menu -->
                                            <!--  Menu -->
                                            <div class="col-12 pt-3">
                                                <div class="form-group">
                                                    <div v-if="menuLoading" class="text-center">
                                                        <span class="spinner-grow spinner-grow-sm mr-1" 
                                                            role="status" 
                                                            aria-hidden="true">
                                                        </span>
                                                    </div>
                                                    <select v-bind:style="{display: inputDisplay}" class="form-control custom-select"
                                                        v-if="!menuLoading" 
                                                        v-model="row.menu_id">
                                                        <option value="">Select Menu</option>
                                                        <option v-for="(menu, index) in menus" 
                                                                :key="index"
                                                                
                                                                :value="menu.id">
                                                                {{ menu.title }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <!--  End Menu -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End NavThree -->

                        </div>
                    </div>
                </div>
                <!-- End Content -->

                    

                    <div class="col-md-12 row">
                        <div class="form-group mr-2">
                            <button class="btn btn-primary" :disabled="btnLoading">
                                <span v-if="btnLoading">
                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                        role="status" aria-hidden="true">
                                    </span>Loading...
                                </span>
                                <span v-if="!btnLoading" class="ti-check-box"></span>
                                <span v-if="!btnLoading" class="text-capitalize"> Create {{ refs }}</span>
                            </button>
                        </div>

                        <div class="form-group">
                            <button type="button" class="btn btn-danger" 
                                :disabled="btnLoading" 
                                @click="cancel">
                                <span class="ti-close"></span>
                                <span> Cancel </span>
                            </button>
                        </div>
                    </div>


                </form>
            </div>


                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->
        
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import Multiselect from 'vue-multiselect';
    import iziToast from 'izitoast';
    
    export default {
        name: 'Create',
        components: {
            Header,
            Navigation,
            Footer,
            Editor,
            Multiselect
        },
        data(){
            return {
                //
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    // meta
                    meta_title: '',
                    meta_keywords: '',
                    meta_description: '',

                    //sitemap
                    sitemap_freq: 'monthly',
                    sitemap_priority: 0.5,

                    // row
                    page_title: '',
                    slug: '',
                    title: '',
                    body: '',
                    sort: 0,

                    // image
                    image_preview: '',
                    image_base64: '',
                    image_alt: '',
                    image_title: '',

                    // mobile image
                    mobile_image_preview: '',
                    mobile_image_base64: '',
                    mobile_image_alt: '',
                    mobile_image_title: '',

                    // status & visibility
                    status: 1,
                    view_in_home: 0,
                    view_in_sitemap:0,
                    view_in_menu: 0,
                    view_in_sub_menu: 0,
                    menu_id: '',
                    menu_order: '',
                    //language
                    language_id:'',
                    // linked FAQs (vue-multiselect: array of { id, title, ... })
                    faqsValues: [],
                },
                editor: {
                    api_key: window.editor_apiKey,
                    menubar: window.editor_menubar,
                    plugins:[window.editor_plugins],
                    external_plugins: window.editor_external_plugins,
                    toolbar: window.editor_toolbar,
                },

                pgLoading: false,
                btnLoading: false,

                // Tenants
                tenant_id: 0,
                tenant_name: '',
                refs: 'pages',

                // language
                languages: [],
                languageLoading: true,

                // menu
                menus: [],
                menuLoading: true,
                inputDisplay: 'none',
                orderDisplay: 'none',

                // FAQs picker
                faqsOptions: [],
                faqsLoading: true,
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }
            this.fetchLanguages();
            this.fetchFaqs();

        },
        methods: {

            // fetch Language
            fetchLanguages(){
                this.languageLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/languages',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.languageLoading = false;
                        this.languages = res.data.rows;
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            fetchFaqs(){
                this.faqsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/faqs',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 200,
                    },
                };
                this.axios(options)
                    .then(res => {
                        this.faqsOptions = res.data.rows || [];
                    })
                    .catch(() => { this.faqsOptions = []; })
                    .finally(() => { this.faqsLoading = false; });
            },
     
            // Add New
            addNew(){
                if(this.tenant_id == 0) {
                    
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenany selected.'
                    });

                } else {

                    if (this.row.status == false) {
                        this.row.status = 0;
                    } else {
                        this.row.status = 1;
                    }
                    if (this.row.view_in_home == false) {
                        this.row.view_in_home = 0;
                    } else {
                        this.row.view_in_home = 1;
                    }
                    if (this.row.view_in_sitemap == false) {
                        this.row.view_in_sitemap = 0;
                    } else {
                        this.row.view_in_sitemap = 1;
                    }

                    if (this.row.view_in_menu == false) {
                        this.row.view_in_menu = 0;
                    } else {
                        this.row.view_in_menu = 1;
                    }

                    if (this.row.view_in_sub_menu == false) {
                        this.row.view_in_sub_menu = 0;
                    } else {
                        this.row.view_in_sub_menu = 1;
                    }
                    
                    this.btnLoading = true;
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                        'Authorization': `Bearer ` + this.auth.access_token,
                    };
                    const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                    const options = {
                        url: window.baseURL+'/'+this.refs,
                        method: 'POST',
                        data: {
                            tenant_id: this.tenant_id,
                            // meta 
                            meta_title: this.row.meta_title,
                            meta_keywords: this.row.meta_keywords,
                            meta_description: this.row.meta_description,

                            //sitemap
                            sitemap_freq: this.row.sitemap_freq,
                            sitemap_priority: this.row.sitemap_priority,

                            // row
                            page_title: this.row.page_title,
                            title: this.row.title,
                            slug: this.row.slug,
                            body: this.row.body,
                            sort: this.row.sort,

                            // image
                            image_base64: this.row.image_base64,
                            image_alt: this.row.image_alt,
                            image_title: this.row.image_title,

                            // mobile image 
                            mobile_image_base64: this.row.mobile_image_base64,
                            mobile_image_alt: this.row.mobile_image_alt,
                            mobile_image_title: this.row.mobile_image_title,

                            // status & visibility
                            status: this.row.status,
                            view_in_home: this.row.view_in_home,
                            view_in_sitemap: this.row.view_in_sitemap,
                            view_in_menu: this.row.view_in_menu,
                            menu_order: this.row.menu_order,
                            view_in_sub_menu: this.row.view_in_sub_menu,
                            menu_id: this.row.menu_id,

                            //language
                            language_id: this.row.language_id,

                            faqs: (this.row.faqsValues || []).map(f => f.id),
                        }
                    }
                    this.axios(options, config)
                        .then(() => {
                            this.btnLoading = false;
                            iziToast.success({
                                icon: 'ti-check',
                                title: 'Great job,',
                                message: 'Item Added Successfully.',
                            });
                            this.$router.push({ name: this.refs });
                        })
                        .catch(err => {
                            // 403 Forbidden
                            if(err.response && err.response.status == 401) {
                                this.removeLocalStorage();
                                this.$router.push({ name: 'login' });
                            } else if(err.response && err.response.status == 403) {
                                this.$router.push({ name: 'forbidden' });
                            } else {
                                this.btnLoading = false;
                                iziToast.warning({
                                    icon: 'ti-alert',
                                    title: 'Wow-man,',
                                    message: err.response.data.message
                                });
                            }
                        })
                        .finally(() => {})
                }
            },

            // Title
            onTitleChange() {
                this.onSlugChange(this.row.title);
            },

            // on Paste
            onSlugPaste(){
                let str = this.row.slug;
                this.onSlugChange(str);
            },
            onSlugChange(str=''){
                if(!str) {
                    str = this.row.slug;
                }
                this.row.slug = str.replace(/\s+/g, '-');
            },


            // Upload Featured image
            onImageChange(e){
                const file = e.target.files[0];
                this.row.image_preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image_base64 = e.target.result;
                };
            },

            // Upload Mobile Featured image
            onMobileImageChange(e){
                const file = e.target.files[0];
                this.row.mobile_image_preview = URL.createObjectURL(file);
                this.createBase64MobileImage(file);
            },
            createBase64MobileImage(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.mobile_image_base64 = e.target.result;
                };
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },

            // view in home
            onViewInHome(){
                if(this.row.view_in_home)
                    this.row.view_in_home = 0;
                else
                    this.row.view_in_home = 1;
            }, 

            //view in sitemap
            onSitemap(){
                if(this.row.view_in_sitemap)
                    this.row.view_in_sitemap = 0;
                else
                    this.row.view_in_sitemap = 1;
            },
            // view in menu
            onViewInMenu(){
                if(this.row.view_in_menu) {
                    this.row.view_in_menu = 0;
                    this.orderDisplay = 'none';
                }
                else {
                    this.row.view_in_menu = 1;
                    this.orderDisplay = 'block';
                }
            },

            // view in sub menu
            onViewInSubMenu(){
                if(this.row.view_in_sub_menu) {
                    this.row.view_in_sub_menu = 0;
                    this.inputDisplay = 'none';
                }
                else {
                    this.row.view_in_sub_menu = 1;
                    this.inputDisplay = 'block';
                }
            },

            // fetchMenus
            fetchMenus() {
                this.menuLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/menus',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.menuLoading = false;
                    this.menus = res.data.rows;                    
                })
                .catch(() => {})
                .finally(() => {});
            },

            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            // toggleCollapse
            collapseToggle(div) {
                if (div == 'Status') {
                    this.fetchMenus();
                }
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },

        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
